import { RequiredFields } from "src/utils/constants";
import { Gender, Level } from "types/code-generator";

export function getMissingRequiredFields(args: {
  user: {
    level: Level;
    address1: string;
    phone: string;
    birthDate: Date;
    emergencyContactName: string;
    gender: Gender;
    avatar: {
      url: string;
    };
  };
  requiredFields: RequiredFields[];
}) {
  const missingRequiredFields: Set<RequiredFields> = new Set();

  if (args.user.level === Level.AccountOwner) {
    for (const f of args.requiredFields) {
      if (f === RequiredFields.AccountAddressRequired && !args.user.address1) {
        missingRequiredFields.add(f);
        break;
      }

      if (f === RequiredFields.AccountPhoneNumberRequired && !args.user.phone) {
        missingRequiredFields.add(f);
        break;
      }
    }
  }

  if (args.user.level === Level.Student) {
    for (const f of args.requiredFields) {
      if (
        f === RequiredFields.ParticipantBirthdateRequired &&
        !args.user.birthDate
      ) {
        missingRequiredFields.add(f);
        break;
      }

      if (
        f === RequiredFields.ParticipantEmergencyContactRequired &&
        !args.user.emergencyContactName
      ) {
        missingRequiredFields.add(f);
        break;
      }

      if (f === RequiredFields.ParticipantGenderRequired && !args.user.gender) {
        missingRequiredFields.add(f);
        break;
      }

      if (f === RequiredFields.ParticipantPhotoRequired && !args.user.avatar) {
        missingRequiredFields.add(f);
        break;
      }
    }
  }

  return Array.from(missingRequiredFields);
}
